export class Leo {

    developerName: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    contactPerson: string;
    contactPhone: string;
    directEmail: string;
    docketFilingNumber: string;
    interconnectingUtility: string;
    projectSize: string;    
    dateFiled: Date;
    utilityIdentification: string;
    technologyType: string;
    county: string;
    descriptionOfProject: string;
    dateEstablishedLeo: Date;
    seekingLeoForEnergyOrCapacity: string;
    stepsToMeetCriteria: string;
    goodFaithEffort: string;
    natureOfConflict: string;
}
